import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { ClockIcon, BookOpenIcon, ClipboardCheckIcon, HomeIcon, CalculatorIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section id="que-incluye" className="w-full bg-white py-16 md:py-24" ref={ref} data-id="element-281">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-283">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-navy-900 mb-4" data-id="element-284">
            Qué incluye el protocolo
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-285" />
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-286">
          {/* Card 1 */}
          <motion.div variants={cardVariants} className="bg-cream-50 border border-cream-200 rounded-xl p-6 sm:p-8" data-id="element-287">
            <div className="w-12 h-12 bg-gold-500/15 rounded-lg flex items-center justify-center mb-4" data-id="element-288">
              <ClockIcon className="w-6 h-6 text-gold-600" aria-hidden="true" data-id="element-289" />
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-2" data-id="element-290">
              Protocolo de las 72 Horas
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-291">
              El plan de choque para conectividad, transporte inicial y
              seguridad desde el minuto 1. Sabrás exactamente qué hacer al bajar
              del avión.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={cardVariants} className="bg-cream-50 border border-cream-200 rounded-xl p-6 sm:p-8" data-id="element-292">
            <div className="w-12 h-12 bg-gold-500/15 rounded-lg flex items-center justify-center mb-4" data-id="element-293">
              <BookOpenIcon className="w-6 h-6 text-gold-600" aria-hidden="true" data-id="element-294" />
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-2" data-id="element-295">
              E-Book: Misión USA 30 Días
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-296">
              La guía paso a paso dividida en 4 fases críticas: Identidad,
              Finanzas, Vivienda y Familia. Todo en orden secuencial.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={cardVariants} className="bg-cream-50 border border-cream-200 rounded-xl p-6 sm:p-8" data-id="element-297">
            <div className="w-12 h-12 bg-gold-500/15 rounded-lg flex items-center justify-center mb-4" data-id="element-298">
              <ClipboardCheckIcon className="w-6 h-6 text-gold-600" aria-hidden="true" data-id="element-299" />
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-2" data-id="element-300">
              Checklist Interactivo de Trámites
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-301">
              Una lista de verificación para que no olvides ni un solo documento
              ante el Social Security, el DMV o la Escuela.
            </p>
          </motion.div>

          {/* Card 4 */}
          <motion.div variants={cardVariants} className="bg-cream-50 border border-cream-200 rounded-xl p-6 sm:p-8" data-id="element-302">
            <div className="w-12 h-12 bg-gold-500/15 rounded-lg flex items-center justify-center mb-4" data-id="element-303">
              <HomeIcon className="w-6 h-6 text-gold-600" aria-hidden="true" data-id="element-304" />
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-2" data-id="element-305">
              Guía de Vivienda "Sin Crédito"
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-306">
              Estrategias reales para rentar con dueño directo y guiones de
              negociación para Landlords que acepten tu situación.
            </p>
          </motion.div>

          {/* Card 5 — full width */}
          <motion.div variants={cardVariants} className="md:col-span-2 bg-navy-900 border border-navy-700 rounded-xl p-6 sm:p-8" data-id="element-307">
            <div className="flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-308">
              <div className="w-12 h-12 bg-gold-500/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-309">
                <CalculatorIcon className="w-6 h-6 text-gold-500" aria-hidden="true" data-id="element-310" />
              </div>
              <div data-id="element-311">
                <h3 className="font-heading text-xl font-bold text-white mb-2" data-id="element-312">
                  Calculadora de "Burn Rate" Inicial
                </h3>
                <p className="font-body text-navy-200 leading-relaxed" data-id="element-313">
                  Una plantilla para presupuestar tus gastos de instalación y
                  proteger tu capital de reserva. Sabrás exactamente cuánto
                  dinero necesitas y cuánto te queda cada semana.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}